import { createGenericApiSlice } from '../../../Api/Factory/genericApiFactory';
import { TagTypes } from '../../../Api/Types/tagTypes';
import { CashDocumentDto, CreateCashDocumentRequest } from '../Types/cashDocumentTypes';

export const cashDocumentsApi = createGenericApiSlice<CashDocumentDto, CreateCashDocumentRequest>({
  reducerPath: 'cashDocumentsApi',
  tag: TagTypes.CashDocument,
  endpoint: 'cash-documents',
});

export const {
  useGetAllQuery: useGetAllCashDocumentsQuery,
  useGetByIdQuery: useGetCashDocumentByIdQuery,
  useCreateMutation: useCreateCashDocumentMutation,
  useUpdateMutation: useUpdateCashDocumentMutation,
  useDeleteMutation: useDeleteCashDocumentMutation,
} = cashDocumentsApi;
